export default __webpack_public_path__ + "static/KFPEPE-79e671d97d125d22baa4daa61f3cbd8f.png";